module.exports = __webpack_public_path__ + "static/bg-2a-guerra-0527b69c0ffcaa8919306f2246165639.jpg";